export default __webpack_public_path__ + "static/media/1293.6ab392b2.png";